import { Calendar, CreditCard, Mail, Phone, AlertCircle, Info, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const infoItems = [
  {
    icon: Calendar,
    title: "Validité",
    description: "6 mois à partir de la confirmation du paiement."
  },
  {
    icon: CreditCard,
    title: "Paiement",
    description: "Le règlement s'effectue par carte bancaire de manière sécurisée via Stripe."
  },
  {
    icon: Mail,
    title: "Envoi",
    description: "Votre carte cadeau vous sera envoyée par email immédiatement après le paiement."
  },
  {
    icon: Phone,
    title: "Utilisation",
    description: "Le bénéficiaire devra prendre rendez-vous en mentionnant le code du bon cadeau."
  },
  {
    icon: Users,
    title: "Clientèle",
    description: "Institut réservé à une clientèle féminine."
  },
  {
    icon: AlertCircle,
    title: "Conditions",
    description: "Les bons cadeaux ne sont ni échangeables, ni remboursables."
  }
];

const GiftCardInfo = () => {
  return (
    <section className="section-container-compact">
      <div className="max-w-4xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="info" className="border-primary/20 bg-card/50 rounded-lg px-6">
            <AccordionTrigger className="hover:no-underline py-5">
              <div className="flex items-start gap-3 text-left w-full pr-4">
                <Info className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                  <h3 className="font-semibold text-lg text-foreground mb-2">
                    À savoir avant de commander
                  </h3>
                  <div className="flex flex-wrap gap-2 text-sm">
                    <Badge variant="secondary" className="font-normal">
                      📅 6 mois
                    </Badge>
                    <Badge variant="secondary" className="font-normal">
                      💳 Sécurisé
                    </Badge>
                    <Badge variant="secondary" className="font-normal">
                      ✉️ Immédiat
                    </Badge>
                    <Badge variant="secondary" className="font-normal">
                      👩 Clientèle féminine
                    </Badge>
                    <Badge variant="secondary" className="font-normal">
                      ⚠️ Non remboursable
                    </Badge>
                  </div>
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent className="pb-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 pt-2">
                {infoItems.map((item, index) => {
                  const Icon = item.icon;
                  return (
                    <Card 
                      key={index} 
                      className="border-border/50 bg-background/50"
                    >
                      <CardContent className="p-4">
                        <div className="flex flex-col gap-3">
                          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                            <Icon className="w-5 h-5 text-primary" />
                          </div>
                          <div>
                            <h4 className="font-semibold text-base text-foreground mb-1.5">
                              {item.title}
                            </h4>
                            <p className="text-muted-foreground text-sm leading-relaxed">
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
};

export default GiftCardInfo;
